module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event4/younite-event-ja-d335375e796035018e80049e34d62ac0.png";